import React, { useEffect, useState } from 'react'
import { Grid, Stack } from '@mui/material'
import { MainContainer } from '../../containers'
import { MainButton } from '../../helpers'
import { ModalHeader } from '../../modals'
import { AddressTab } from './AddressTab'
import { bottomPosition, customStyles } from '../../../styles'
import { AddressForm } from './AddressForm'
import { RegularTab } from '../../helpers/tabs/RegularTab'
import HomeIcon from '@mui/icons-material/Home';
import ApartmentIcon from '@mui/icons-material/Apartment';
import { useNavigate, useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { editAccount, filterAccountsbyService, loadingAccounts, successAccounts, getTypeAccount } from '../../../slices/accountsSlice'
import { useLocalStorage } from '../../../hooks/useLocalStorage'
import { getAccountsAction } from '../../../actions'
import { NoAccounts } from '../account/NoAccounts'
import { resetForm } from '../../../slices/fillAddressSlice'
export const AddressSaved = React.forwardRef(( props, ref) => {
  const navigate = useNavigate()
  const { data, editMode, accountsByService, isFiltered } = useSelector(state => state.accounts)
  const [dataSecure, setDataSecure] = useState([])
  const { code } = useSelector(state => state.status)
  const dispatch = useDispatch()
  const { id } = useParams()
  const byId = id.toUpperCase()
  const [ userAuthorization, setValue ] = useLocalStorage('login-token', null)
  
  const handleNavigate = () => {
    navigate(`/dashboard/${byId.toLowerCase()}/nueva-direccion`)
 }
  const backward = () => {
    navigate(`/dashboard/content`)
 }
 useEffect(() => {
   dispatch(filterAccountsbyService (byId) )
   dispatch(getTypeAccount(byId))
   dispatch(editAccount({editMode: false}))
   dispatch(resetForm())
  }, [])
  
  useEffect(() => {
     accountsByService.length === 0 && dispatch(getAccountsAction(userAuthorization?.token))
  }, [ accountsByService ])
  
//   useEffect(() => {
//     isFiltered ? setDataSecure(accountsByService) : setDataSecure(data)
//  }, [data, accountsByService, dispatch])


  return (
    
   <MainContainer>
      <ModalHeader text="Direcciones" backward action={backward} bold color={ customStyles.colors.main }/>
      <Grid container xs={12} spacing={3} mb={3}>
      {
        accountsByService.length > 0
        ? accountsByService.map(item => (
          <RegularTab id={item.id}key={item.id} icon={HomeIcon} title={item.alias} content={`${item.street} ${item.extNumber} ${item.colony} ${item.postalCode}`} serviceType={item.type} postalCode={item.postalCode} route="product" data={item}/>
          ))
          : <NoAccounts />
        }
    </Grid>
      <MainButton variant="contained" text="AGREGAR DIRECCION" size={ customStyles.buttonSize.full } onClick={handleNavigate}/> 
      {/* <AddressForm /> */}
   </MainContainer>
  )
})
